import { GeocodeResult } from '@googlemaps/google-maps-services-js';

interface ParsedLocation {
    city: string;
    country: string;
    street: string;
    zip: string;
    lat: number;
    lng: number;
}

export function parseGeocodeResult(geocodeResult: GeocodeResult): ParsedLocation {
    let city = '';
    let country = '';
    let street = '';
    let streetNumber = '';
    let zip = '';

    geocodeResult.address_components.forEach((component) => {
        component.types.forEach((type) => {
            switch (type) {
                case 'street_number':
                    streetNumber = component.short_name;
                    break;
                case 'route':
                    street = component.short_name;
                    break;
                case 'locality':
                case 'postal_town':
                case 'administrative_area_level_3':
                    city = component.long_name;
                    break;
                case 'country':
                    country = component.short_name.toLowerCase();
                    break;
                case 'postal_code':
                    zip = component.short_name;
                    break;
            }
        });
    });

    return {
        city,
        country,
        street: `${street}${streetNumber ? ' ' + streetNumber : ''}`,
        zip,
        lat: geocodeResult.geometry.location.lat,
        lng: geocodeResult.geometry.location.lng,
    };
}
